<template>
  <k-panel class="ks-floating-menu">
    <template #title>{{instance.title}}</template>
    <template #buttons>
      <k-btn size="m" icon @click="show = !show">
        <k-icon>{{ show ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</k-icon>
      </k-btn>
    </template>
    <template #default>
      <div v-if="show">
        <h3>Relays</h3>
        <k-layout>
          <k-flex c6 class="pa-2">Relay</k-flex>
          <k-flex c6 class="pa-2"></k-flex>
        </k-layout>
        <template v-for="relay in relays">
          <k-divider></k-divider>
          <k-layout>
            <k-flex xs6 class="py-2" style="vertical-align: middle;">{{relay.name}}</k-flex>
            <k-flex xs6 class="py-2" style="text-align: right;">
              <k-btn :color="relay.state ? 'red' : 'green'" small icon flat><k-icon>circle</k-icon></k-btn>
              <k-btn color="warning" small @click="reset_device(relay.device)" :loading="loading_button(relay)" :disabled="loading_button(relay)">Reset</k-btn>
            </k-flex>
          </k-layout>
        </template>
      </div>
    </template>
  </k-panel> 
</template>

<script>
import InstanceModel from '@/models/instance.js'

export default {
  props: ['id'],
  data () {
    var ch = this.$cloudserver.channel("instances:status:"+this.id);
    return {
      show: false,
      ws_channel: ch,
      loading_buttons: {}
    }
  },
  created() {
    this.ws_channel.join();
  },
  computed: {
    instance () {
      return InstanceModel.instance_by_id(this.id);
    },
    relay_states () {
      return _.get(this.ws_channel.data, "instance.relays", []);
    },
    relays() {
      return _.map(this.relay_states, (state, device) => {
        return {state: state, device: device+1, name: _.get(this.instance, ["meta", "relay_names", device], "Unused")}
      })
    },
    is_empty() {
      return _.isEmpty(this.relays);
    }
  },
  methods: {
    loading_button(relay) {
      return this.loading_buttons[relay.device] || relay.state;
    },
    reset_device(device) {
      this.loading_buttons[device] = true;
      this.$nextTick(() => {
        InstanceModel.send_command_to_external_device(this.instance, "reset-device", {device: device}, () => {}, () => {});
        setTimeout(() => {
          this.loading_buttons[device] = false;
        }, 5000);
      });

    }
  }
}
</script>
